import { Grid } from "@mui/material";
import { useCallback, useMemo } from "react";
import type { AmountType, FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureField } from "../../../../../../../../../api/types/svTypes.ts";
import { getMeasureAmountTypeField } from "../../../../../utilities/isConfigurationValid.ts";
import AmountTypeFieldControl from "../AmountTypeFieldControl.tsx";

interface Props {
  measure: MeasureField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  disabled?: boolean;
}

const AmountTypeMenuItem = ({ measure, disabled, saveChanges }: Props) => {
  const amountField = useMemo(() => getMeasureAmountTypeField(measure), [measure]);

  const handleOnChange = useCallback(
    (amountType: AmountType) => {
      saveChanges({ amountType: amountType }, false);
    },
    [saveChanges]
  );

  if (!amountField) return null;

  return (
    <Grid container sx={{ width: "100%" }}>
      <AmountTypeFieldControl
        amountType={amountField}
        disabled={!measure.meta.capabilities.changeAmountField || disabled}
        onChange={handleOnChange}
      />
    </Grid>
  );
};

export default AmountTypeMenuItem;
